import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Permission from './Permission';
import Pathname from './Pathname';

const CAMPUS_CODE = 'RMUTI';

class SettingSidebar extends Component {
  render(){
    var fullPathname = Pathname.fullPathname(this.props.location);
    const { siteSetting } = this.props;

    return(
      <div className="settings-sidebar pl-4 pl-lg-0 sub-sidebar-menu">
        {Permission.isAdmin() && (
          <ul className="nav flex-column nav-pills py-4 settings-sidebar" id="v-pills-tab" role="tablist">
            <li className="nav-item">
              <Link to='/settings/actings' className={`nav-link ${(fullPathname.startsWith('/settings/actings')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                ตั้งค่ารักษาราชการ
              </Link>
            </li>
            <li className="nav-item">
              <Link to='/settings/sitesetting' className={`nav-link ${(fullPathname.startsWith('/settings/sitesetting')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                ตั้งค่า site
              </Link>
            </li>
            <li className="nav-item">
              <Link to='/settings/signature' className={`nav-link ${(fullPathname.startsWith('/settings/signature')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                จัดการลายมือชื่อ
              </Link>
            </li>
            <li className="nav-item">
              <Link to='/settings/workflow_migration' className={`nav-link ${(fullPathname.startsWith('/settings/workflow_migration')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                ย้ายภาระงาน
              </Link>
            </li>
            {siteSetting && siteSetting.code_name === CAMPUS_CODE && (
              <li className="nav-item">
                <Link to='/settings/campuses' className={`nav-link ${(fullPathname.startsWith('/settings/campuses')) && 'active'}`}>
                  <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                  จัดการวิทยาเขต
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link to='/settings/notices' className={`nav-link ${(fullPathname.startsWith('/settings/notices')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                จัดการรายการประชาสัมพันธ์
              </Link>
            </li>
          </ul>
        )}

        {!Permission.isAdmin() && Permission.isSuperAdmin() && (
          <ul className="nav flex-column nav-pills py-4 settings-sidebar" id="v-pills-tab" role="tablist">
            <li className="nav-item">
              <Link to='/settings/setup' className={`nav-link ${(fullPathname.startsWith('/settings/setup')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                ตั้งค่า site
              </Link>
            </li>
          </ul>
        )}

        {(Permission.isSecretary() || Permission.isCorrespondence()) && (
          <ul className="nav flex-column nav-pills py-4 settings-sidebar" id="v-pills-tab" role="tablist">
            <li className="nav-item">
              <Link to='/settings/actings' className={`nav-link ${(fullPathname.startsWith('/settings/actings')) && 'active'}`}>
                <i className="fa fa-cog mr-2" aria-hidden="true"></i>
                ตั้งค่ารักษาราชการ
              </Link>
            </li>
          </ul>
        )}
      </div>
    )
  }
}

export default SettingSidebar;


// WEBPACK FOOTER //
// ./src/components/SettingSidebar.js